import type {ReactElement} from 'react';
import {createRoot} from 'react-dom/client';
import App from '@Components/app';
import {AiContentVerify} from '@Components/ai-content-verify/ai-content-verify';
import {AI_CONTENT_VERIFY_ROOT_ID} from '@Components/ai-content-verify/ai-content-verify.types';
import {useLoadI18} from '@Hooks/useLoadI18';

// eslint-disable-next-line react-refresh/only-export-components
function AiContentVerifyApp(): ReactElement {
  const isI18nReady = useLoadI18();

  if (!isI18nReady) {
    return <App />;
  }

  return (
    <App>
      <AiContentVerify />
    </App>
  );
}

const rootElement = document.getElementById(AI_CONTENT_VERIFY_ROOT_ID);

if (rootElement) {
  createRoot(rootElement).render(<AiContentVerifyApp />);
}
